import script from "./customFieldInputComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./customFieldInputComponent.vue?vue&type=script&setup=true&lang=js"

import "./customFieldInputComponent.vue?vue&type=style&index=0&id=156860a7&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-156860a7"]])

export default __exports__